export default "__VITE_ASSET__CJ_6vxIh__"